import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Request token

export const PASSWORD_RESET_PHONE_REQUEST_TOKEN_TRIGGER = 'PASSWORD_RESET_PHONE_REQUEST_TOKEN_TRIGGER';
export interface PasswordResetPhoneRequestTokenTriggerAction {
    readonly type: typeof PASSWORD_RESET_PHONE_REQUEST_TOKEN_TRIGGER;
    readonly countryPrefix: string;
    readonly rawPhoneNumber: string;
    readonly resend: boolean;
}

export const PASSWORD_RESET_PHONE_REQUEST_TOKEN_REQUEST = 'PASSWORD_RESET_PHONE_REQUEST_TOKEN_REQUEST';
export interface PasswordResetPhoneRequestTokenRequestAction extends APIRequestAction {
    readonly type: typeof PASSWORD_RESET_PHONE_REQUEST_TOKEN_REQUEST;
    readonly countryPrefix: string;
    readonly rawPhoneNumber: string;
}

export const PASSWORD_RESET_PHONE_REQUEST_TOKEN_SUCCESS = 'PASSWORD_RESET_PHONE_REQUEST_TOKEN_SUCCESS';
export interface PasswordResetPhoneRequestTokenNormalizedResponse extends NormalizedResponse {
    readonly result: { fullPhoneNumber: string; };
}
export interface PasswordResetPhoneRequestTokenSuccessAction extends APISuccessAction<PasswordResetPhoneRequestTokenNormalizedResponse> {
    readonly type: typeof PASSWORD_RESET_PHONE_REQUEST_TOKEN_SUCCESS;
    readonly countryPrefix: string;
    readonly rawPhoneNumber: string;
}

export const PASSWORD_RESET_PHONE_REQUEST_TOKEN_FAILURE = 'PASSWORD_RESET_PHONE_REQUEST_TOKEN_FAILURE';
export interface PasswordResetPhoneRequestTokenFailureAction extends APIFailureAction {
    readonly type: typeof PASSWORD_RESET_PHONE_REQUEST_TOKEN_FAILURE;
    readonly countryPrefix: string;
    readonly rawPhoneNumber: string;
}

export const passwordResetPhoneRequestTokenTrigger = (countryPrefix: string, rawPhoneNumber: string, resend: boolean): PasswordResetPhoneRequestTokenTriggerAction => ({
    type: PASSWORD_RESET_PHONE_REQUEST_TOKEN_TRIGGER,
    countryPrefix, rawPhoneNumber, resend,
});

export const passwordResetPhoneRequestTokenApi = {
    request: (countryPrefix: string, rawPhoneNumber: string): PasswordResetPhoneRequestTokenRequestAction => ({
        type: PASSWORD_RESET_PHONE_REQUEST_TOKEN_REQUEST,
        countryPrefix, rawPhoneNumber,
    }),
    success: (countryPrefix: string, rawPhoneNumber: string, response: PasswordResetPhoneRequestTokenNormalizedResponse): PasswordResetPhoneRequestTokenSuccessAction => ({
        type: PASSWORD_RESET_PHONE_REQUEST_TOKEN_SUCCESS,
        countryPrefix, rawPhoneNumber, response,
    }),
    failure: (countryPrefix: string, rawPhoneNumber: string, error: any): PasswordResetPhoneRequestTokenFailureAction => ({
        type: PASSWORD_RESET_PHONE_REQUEST_TOKEN_FAILURE,
        countryPrefix, rawPhoneNumber, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Validate token

export const PASSWORD_RESET_PHONE_VALIDATE_TOKEN_TRIGGER = 'PASSWORD_RESET_PHONE_VALIDATE_TOKEN_TRIGGER';
export interface PasswordResetPhoneValidateTokenTriggerAction {
    readonly type: typeof PASSWORD_RESET_PHONE_VALIDATE_TOKEN_TRIGGER;
    readonly token: string;
    readonly fullPhoneNumber: string;
}

export const PASSWORD_RESET_PHONE_VALIDATE_TOKEN_REQUEST = 'PASSWORD_RESET_PHONE_VALIDATE_TOKEN_REQUEST';
export interface PasswordResetPhoneValidateTokenRequestAction extends APIRequestAction {
    readonly type: typeof PASSWORD_RESET_PHONE_VALIDATE_TOKEN_REQUEST;
    readonly token: string;
    readonly fullPhoneNumber: string;
}

export const PASSWORD_RESET_PHONE_VALIDATE_TOKEN_SUCCESS = 'PASSWORD_RESET_PHONE_VALIDATE_TOKEN_SUCCESS';
export interface PasswordResetPhoneValidateTokenNormalizedResponse extends NormalizedResponse {
    readonly result: { passwordResetToken: string; };
}
export interface PasswordResetPhoneValidateTokenSuccessAction extends APISuccessAction<PasswordResetPhoneValidateTokenNormalizedResponse> {
    readonly type: typeof PASSWORD_RESET_PHONE_VALIDATE_TOKEN_SUCCESS;
    readonly token: string;
    readonly fullPhoneNumber: string;
}

export const PASSWORD_RESET_PHONE_VALIDATE_TOKEN_FAILURE = 'PASSWORD_RESET_PHONE_VALIDATE_TOKEN_FAILURE';
export interface PasswordResetPhoneValidateTokenFailureAction extends APIFailureAction {
    readonly type: typeof PASSWORD_RESET_PHONE_VALIDATE_TOKEN_FAILURE;
    readonly token: string;
    readonly fullPhoneNumber: string;
}

export const passwordResetPhoneValidateTokenTrigger = (token: string, fullPhoneNumber: string): PasswordResetPhoneValidateTokenTriggerAction => ({
    type: PASSWORD_RESET_PHONE_VALIDATE_TOKEN_TRIGGER,
    token, fullPhoneNumber,
});

export const passwordResetPhoneValidateTokenApi = {
    request: (token: string, fullPhoneNumber: string): PasswordResetPhoneValidateTokenRequestAction => ({
        type: PASSWORD_RESET_PHONE_VALIDATE_TOKEN_REQUEST,
        token, fullPhoneNumber,
    }),
    success: (token: string, fullPhoneNumber: string, response: PasswordResetPhoneValidateTokenNormalizedResponse): PasswordResetPhoneValidateTokenSuccessAction => ({
        type: PASSWORD_RESET_PHONE_VALIDATE_TOKEN_SUCCESS,
        token, fullPhoneNumber, response,
    }),
    failure: (token: string, fullPhoneNumber: string, error: any): PasswordResetPhoneValidateTokenFailureAction => ({
        type: PASSWORD_RESET_PHONE_VALIDATE_TOKEN_FAILURE,
        token, fullPhoneNumber, error,
    }),
};
